<template>
  <div style="background: #fff">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          {{ getTitle('footer.message') }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="wrapper">
      <div class="title">
        <h2>{{ getTitle('page.message') }}</h2>
      </div>
      <div class="form">
        <el-form
          :model="feedback"
          ref="feedback"
          label-width="100px"
          class="feedback-form"
        >
          <!-- <el-form-item
            :label="getTitle('page.contacts')"
            prop="contacts"
            :rules="[
              {
                required: true,
                message: getTitle('page.contactsInput'),
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="feedback.contacts"
              :placeholder="getTitle('page.contactsInput')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="getTitle('page.mobile')"
            prop="phone"
            :rules="[
              {
                required: true,
                message: getTitle('page.mobileInput'),
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="feedback.phone"
              :placeholder="getTitle('page.mobileInput')"
            ></el-input>
          </el-form-item> -->
          <el-form-item
            :label="getTitle('page.type')"
            prop="toushu_type"
            :rules="[
              {
                required: true,
                message: getTitle('page.typeInput'),
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              v-model="feedback.toushu_type"
              :placeholder="getTitle('page.typeInput')"
            >
              <el-option
                v-for="item in type"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="getTitle('page.title')"
            prop="title"
            :rules="[
              {
                required: true,
                message: getTitle('page.titleInput'),
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="feedback.title"
              :placeholder="getTitle('page.titleInput')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="getTitle('page.content')"
            prop="toushu_content"
            :rules="[
              {
                required: true,
                message: getTitle('page.contentInput'),
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              type="textarea"
              v-model="feedback.toushu_content"
              :placeholder="getTitle('page.contentInput')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('feedback')">{{
              getTitle('page.submit')
            }}</el-button>
            <el-button @click="resetForm('feedback')">{{
              getTitle('page.reset')
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import www from '@/api/www';
import user from '@/setup/user';
export default {
  data() {
    return {
      feedback: {
        workflow_id: 3,
        transition_id: 27,
        toushu_type: [],
        title: '',
        toushu_content: '',
      },
      type: [
        { value: 'tongyong', label: '通用' },
        { value: 'piaowu', label: '票务' },
        { value: 'jichusheshi', label: '基础设施' },
        { value: 'chuangkourenyuanfuwu', label: '窗口人员服务' },
      ],
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
  },
  async created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
  },
  methods: {
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    async submitForm(formName) {
      if (
        !this.feedback.toushu_type ||
        !this.feedback.title ||
        !this.feedback.toushu_content
      ) {
        alert(this.getTitle('page.required'));
        return;
      }
      let currentUser = user.getUser();
      const messageGet = await www.addFeedback({
        username: currentUser.phone,
        workflow_id: this.feedback.workflow_id,
        transition_id: this.feedback.transition_id,
        toushu_type: this.feedback.toushu_type,
        title: this.feedback.title,
        toushu_content: this.feedback.toushu_content,
      });
      alert(this.getTitle('page.successfully'));
      this.$refs[formName].resetFields();
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     alert('submit!');
      //   } else {
      //     console.log('error submit!');
      //     return false;
      //   }
      // });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 1100px;
  margin: 0 auto;
  overflow: hidden;
  .title {
    padding: 20px 0;
    text-align: center;
    h2 {
      margin: 20px 0;
      color: #191b26;
      font-weight: normal;
      font-size: 30px;
      line-height: 42px;
    }
  }
  .form {
    width: 500px;
    margin: 0 auto 60px;
    .feedback-form {
      margin-left: -100px;
    }
  }
  .feedback-form /deep/ .el-form-item__content {
    text-align: center;
  }
  .feedback-form /deep/ .el-select {
    width: 100%;
  }
  .feedback-form /deep/ textarea {
    min-height: 99px !important;
  }
  .feedback-form /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #31a775;
    background: #31a775;
  }
  .feedback-form /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #31a775;
  }
  .el-button--primary {
    margin-right: 10px;
    border-color: #31a775;
    background-color: #31a775;
  }
}
</style>
